import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import pallet from '../../layouts/pallet';

const CustomMenuItem = styled(MenuItem)(() => ({
  '&.Mui-selected': {
    color: pallet.primary,
    backgroundColor: pallet.hoverBlue,
    fontWeight: 600
  },
  '&.Mui-selected:hover': {
    color: pallet.formLabelText,
    backgroundColor: pallet.hoverAction
  },
  '&:hover': {
    color: pallet.formLabelText,
    backgroundColor: pallet.hoverAction
  }
}));

export default CustomMenuItem;
